import React, { useEffect, useState } from "react";
import FullScreenLoadingView from "presentational/common/FullScreenLoadingView";
import Service from "lib/service-amp";
import Restful from "lib/restful";
import config from "lib/fr-config";
import { withStore } from "store/storeHandler";
/**
 * 회원가입중 referral 값(사용자이름or아웃핏해시)을 전달할때
 * google에서 redirect해서 돌아오는 탓에 url의 쿼리값이 다 지워짐.
 * 그래서 두가지 방법을 병렬사용하는것을 권장했음(지피티가)
 * 1) sessionStorage 사용해서 구글로 리다이렉드 되기 전 값 저장하기.
 * : 같은 origin의 같은 탭에서만 데이터 공유 가능(다른탭으로 진행시 저장값 못읽음)
 * 2) 구글 로그인시 custom state 사용하기
 * : signInWithRedirect({ provider: "Google" }) 실행시 customState값 추가.
 * : 하지만 레퍼럴하나 추가하려다 일반가입자들의 회원가입에러 발생가능성 커서 적용안함
 * (1. customState값 없으면 listener 가 파악못해서 회원가입 멈출 가능성, 이 위험성 피해 사용할 방법 있긴 하지만 그것도 완벽은 아님)
 * (2. 코드 지저분해지고, 그정도로 크리티컬한 사항은 아니라 판단해서. sessionStorage로도 신뢰가 있다 판단해서)
 *
 * 결국 1)만 적용한 상황. 나중에 2) 는 필요시에만 적용하자.
 */

const REFERRAL_QUERY_INDEX = config.referralUrlQueryIndex;

const ROOT_URL = config.rootURL;

function RootGoogleLoginCallback(props) {
  const { viewerLocation, AppErrorActions } = props;

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    init();
  }, [viewerLocation]);

  const init = async () => {
    const isReadyToInit = getIsReadyToInit();
    if (!isReadyToInit) return null;

    const { success, userInfo } = await getUserInfo();

    if (success) {
      await registerUserIfNotExists(userInfo);
    }
  };

  const getIsReadyToInit = () => {
    if (!viewerLocation) return false;
    if (isInitialized) return false;

    setIsInitialized(true);
    return true;
  };

  const goToRootPage = () => {
    window.location.replace(ROOT_URL);
  };

  const getUserInfo = async () => {
    try {
      const { code, res } = await Service.completeGoogleLogin();

      if (code !== "ok") {
        const errObj = Error("google login error!");
        errObj.errorValue = { ...res };
        AppErrorActions.setFatalAppError(errObj);
        goToRootPage();
        return { success: false };
      }

      if (!res) {
        /**
         * 구글 회원가입 도중 사용자가 취소한 경우.
         */
        goToRootPage();
        return { success: false };
      }

      return { success: true, userInfo: res };
    } catch (error) {
      AppErrorActions.setFatalAppError(error);
      goToRootPage();
      return { success: false };
    }
  };

  const getReferralDataFromSessionStorage = () => {
    const { refOutfit, refUsername } = REFERRAL_QUERY_INDEX;
    const refOutfitValue = sessionStorage.getItem(refOutfit);
    const refUsernameValue = sessionStorage.getItem(refUsername);

    if (!!refOutfitValue) {
      return { [refOutfit]: refOutfitValue };
    } else if (!!refUsernameValue) {
      return { [refUsername]: refUsernameValue };
    } else {
      return {};
    }
  };

  const resetReferralData = () => {
    const { refOutfit, refUsername } = REFERRAL_QUERY_INDEX;
    sessionStorage.removeItem(refOutfit);
    sessionStorage.removeItem(refUsername);
  };

  const registerUserIfNotExists = async userInfo => {
    const refObj = getReferralDataFromSessionStorage();
    const data = {
      location: viewerLocation,
      authType: "google",
      ...refObj
    };
    const idToken = userInfo.tokenObj.idToken.getJwtToken();

    const { code, res, errInfo } = await Restful.ensureUserAccountAPI({
      data,
      idToken
    });
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      AppErrorActions.setFatalAppError(errObj);
      return false;
    } else if (
      code === "ReservedWord" ||
      code === "TooLongUsername" ||
      code === "InternalError"
    ) {
      const errObj = Error(`error : ${code}`);
      AppErrorActions.setFatalAppError(errObj);
      return false;
    }

    resetReferralData();

    const { alreadyExistUser, setNewAccount } = res;
    if (alreadyExistUser || setNewAccount) {
      window.location.replace(ROOT_URL);
    }
  };

  return <FullScreenLoadingView />;
}

export default withStore({
  stateMap: {
    userDevice: ["viewerLocation"]
  },
  dispatchMap: ["appError"]
})(RootGoogleLoginCallback);
